import React from 'react';

const variantStyles = {
  default:
    'bg-white text-am-text-900 hover:bg-gray-50 shadow',
  ghost:
    'text-am-text-900 hover:bg-gray-100',
  accent:
    'border border-gray-200 text-am-text-900 hover:bg-am-accent hover:text-white',
};

const shapeStyles = {
  square: 'rounded-md',
  round: 'rounded-full',
};

const sizeStyles = {
  sm: 'p-2',
  md: 'p-3',
  lg: 'p-4',
};

/**
 * Tombol hanya ikon (untuk aksesibilitas wajib ada aria-label).
 * @param {string} variant - 'default' | 'ghost' | 'accent'
 * @param {string} shape - 'square' | 'round'
 * @param {string} size - 'sm' | 'md' | 'lg'
 * @param {string} className - class tambahan
 * @param {React.ReactNode} children - ikon SVG atau karakter
 * @param {string} ariaLabel - wajib untuk aksesibilitas
 */
function IconButton({
  variant = 'default',
  shape = 'square',
  size = 'md',
  className = '',
  children,
  'aria-label': ariaLabel,
  ...rest
}) {
  const base = 'inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-am-accent focus:ring-offset-2 transition disabled:pointer-events-none disabled:opacity-50';
  const combined = [
    base,
    variantStyles[variant],
    shapeStyles[shape],
    sizeStyles[size],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type="button" className={combined} aria-label={ariaLabel} {...rest}>
      {children}
    </button>
  );
}

export default IconButton;
